
<template>

	<div><!-- <myframe ref="frame" title="Анализ невязок" :title_buttons_cols="10" class="m-2" without_border expanded> -->

		<b-row align-v="center" class="mt-2 justify-content-between">

			<b-col cols="3"><v-select v-model="plot_type" :options="plot_types" :clearable="false" required v-on:input="change_plot_type"/></b-col>
			<!-- <b-col cols="3"><v-select v-model="model" :options="models_visible" :clearable="false" required/></b-col> -->
			<b-col cols="3"><v-select v-model="plot" :options="plots" :clearable="false" required/></b-col>
			
			<b-col cols="3" class="d-flex justify-content-end">

				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" class="filter-button" v-b-tooltip:fullscreen.hover.bottomright title="Вернуть в исходное состояние" v-on:click="reset_state"><base-icon name="broomstick" /></b-button>
				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" class="filter-button ml-2" v-b-tooltip:fullscreen.hover.bottomright title="Отмена последнего действия" v-on:click="() => $emit('bring_back')"><base-icon name="actions_undo"/></b-button>

			</b-col>

		</b-row>

		<div align="center" class="mt-2">
			
			<!-- <span v-html="data.printable_formula_html[get_model_id(model)]"/> -->
			<diff_plot v-if="plot == 'График невязок'" ref="plot" :data="data" :plot_type="plot_type" :model="model" :initial_plot_type="plot_type"/>
			<diff_compare_plot v-else ref="plot" :data="data" :model="model" :initial_plot_type="plot_type"/>

		</div>

	</div><!-- </myframe> -->

</template>

<script>

// import myframe from "../../../../../widgets/frame"
import api from "../../../../../../api"
import { bus } from "../../../../../../api/bus"
import o from "./../objects"
import diff_plot from "./diff_plot"
import diff_compare_plot from "./diff_compare_plot"

export default
{
	props :
	{
		id : String,
		data : Object,
	},

	components :
	{
		// myframe,
		diff_plot,
		diff_compare_plot,
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler()
			{
				this.refresh()
			}
		},
	},

	data()
	{
		return {

			service : "cadastral_analogues",

			model : null,
			models : [ "Линейная", "Мультипликативная степенная", "Экспоненциальная" ],
			models_visible : [],

			plot_type : "Все",
			plot_types : [ "Все", "Не выбросы", "Обучающая выборка", "Контрольная выборка" ],

			plot : "График невязок",
			plots : [ "График невязок", "График соотношения невязок" ],

		}
	},

	mounted()
	{
		bus.$on("set_plot_type",
			ev =>
			{
				this.plot_type = ev.plot_type
			})
	},

	methods :
	{
		get_model_id(model)
		{
			if(model == "Линейная")
				return "add"

			if(model == "Мультипликативная степенная")
				return "mult"

			return "exp"
		},

		refresh()
		{
			// var models_visible = []

			// Object.entries(this.data.printable_formula_html).forEach(
			// 	desc =>
			// 	{
			// 		if(desc[1] != null)
			// 			models_visible.push(this.models.find(model => this.get_model_id(model) == desc[0]))
			// 	})

			// if(models_visible.length > 0)
			// {
			// 	this.models_visible = models_visible

			// 	if(this.model == null || ! models_visible.includes(this.model))
			// 		this.model = models_visible[0]
			// }
			this.model = this.data.type
			// this.model = "Линейная"
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		reset_state()
		{
			o.objects().reset_state()
		},

		change_plot_type(plot_type)
		{
			bus.$emit("set_plot_type", { plot_type : plot_type })
		},
	}
}

</script>

